<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Equipamento | {{id}}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
					<div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>

          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="descricao">Descrição <sup class="text-danger">* </sup></label>
              <input id="descricao" v-model="registro.descricao" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.descricao }">
              <span v-show="errors.descricao != null" class="help-inline">{{ errors.descricao }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="numero_serial">Número Serial <sup class="text-danger">* </sup></label>
              <input id="numero_serial" v-model="registro.numero_serial" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.numero_serial }">
              <span v-show="errors.numero_serial != null" class="help-inline">{{ errors.numero_serial }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="idc_status">Status <sup class="text-danger">* </sup></label>
              <select id="idc_status" v-model="registro.idc_status" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.idc_status }">
                <option value="1">Cadastrado</option>
                <option value="2">Disponível</option>
                <option value="3">Em Utilização</option>
                <option value="4">Inativo</option>
              </select>
              <span v-show="errors.idc_status != null" class="help-inline">{{ errors.idc_status }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="mac_address">Número do Frame <sup class="text-danger">* </sup></label>
              <input id="mac_address" v-model="registro.mac_address" v-mask="'##-##-##-##-##-##'" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.mac_address }">
              <span v-show="errors.mac_address != null" class="help-inline">{{ errors.mac_address }}</span>
            </div>
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Cancelar</button>
            <button type="button" id="gravarButton" class="btn btn-success" @click="gravar()">Gravar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Actions from '../../actions/EquipamentoActions'

export default {
  name: 'editar',
  props: ['id'],
  data () {
    return {
      errorMessage: '',
      errors: {},
      hasError: false,
      registro: {
        descricao: '',
        numero_serial: '',
        idc_status: '',
        mac_address: ''
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Editar'

    Actions.obterEquipamento(this.id)
      .then(res => {
        if (res && res.descricao) {
          this.registro = res
        } else {
          this.errorMessage = 'Registro não encontrado.'
        }
      })
      .catch((error) => {
        console.log(error.message)
        this.errorMessage = 'Registro não encontrado.'
      })
  },
  methods: {
    voltar () {
      this.$router.push('/equipamentos')
    },
    validation () {
      this.errors = {}
      this.hasError = false

      if (!this.registro.descricao) {
        this.errors.descricao = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.numero_serial) {
        this.errors.numero_serial = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.mac_address) {
        this.errors.mac_address = 'Este campo deve ser preenchido.'
        this.hasError = true
      } else {
        let macAddress = this.registro.mac_address.match(/[\d]+/g).join('')

        if (macAddress.length !== 12) {
          this.errors.mac_address = 'Número do Frame inválido.'
          this.hasError = true
        }
      }

      if (!this.registro.idc_status) {
        this.errors.idc_status = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
    },
    gravar () {
      this.validation()

      if (!this.hasError) {
        this.$parent.$parent.$data.showModalLoader = true

        Actions.alterarEquipamento({
          id: this.id,
          descricao: this.registro.descricao,
          numero_serial: this.registro.numero_serial,
          mac_address: this.registro.mac_address,
          idc_status: this.registro.idc_status
        })
        .then(response => {
          this.$parent.$parent.$data.showModalLoader = false
          this.$router.push('/equipamentos')
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.'
          this.$parent.$parent.$data.showModalLoader = false
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/distribuicao-equipamentos/Editar.vue